type ShiftType = 'fd' | 'zd' | 'sd' | 'nd';
type FaClass = `fa-${string}`;

export const BaseShifts: { icon: FaClass; control: ShiftType }[] = [
  { icon: 'fa-sunrise', control: 'fd' },
  { icon: 'fa-sun-bright', control: 'zd' },
  { icon: 'fa-clock', control: 'sd' },
  { icon: 'fa-moon-stars', control: 'nd' },
];
